export default __webpack_public_path__ + "static/media/avatar.4f2fe7ce.png";